import createIcon from '../../createIcon';

/**
 * @component @name Terminal
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNEg0QzIuODkgNCAyIDQuOSAyIDZWMThDMiAxOS4xIDIuODkgMjAgNCAyMEgyMEMyMS4xIDIwIDIyIDE5LjEgMjIgMThWNkMyMiA0LjkgMjEuMTEgNCAyMCA0Wk0yMCAxOEg0VjhIMjBWMThaTTE4IDE3SDEyVjE1SDE4VjE3Wk03LjUgMTdMNi4wOSAxNS41OUw4LjY3IDEzTDYuMDggMTAuNDFMNy41IDlMMTEuNSAxM0w3LjUgMTdaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Terminal = createIcon('Terminal', [
  [
    'path',
    {
      d: 'M20 4H4C2.89 4 2 4.9 2 6V18C2 19.1 2.89 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.11 4 20 4ZM20 18H4V8H20V18ZM18 17H12V15H18V17ZM7.5 17L6.09 15.59L8.67 13L6.08 10.41L7.5 9L11.5 13L7.5 17Z',
      key: 'i32zjs',
    },
  ],
]);

export default Terminal;
